var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoIncompleta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 5C9.33074 5 8.80779 5.57786 8.87438 6.2438L9.31281 10.6281C9.34811 10.9811 9.64519 11.25 10 11.25C10.3548 11.25 10.6519 10.9811 10.6872 10.6281L11.1256 6.2438C11.1922 5.57786 10.6693 5 10 5ZM10.0019 12.5C9.31157 12.5 8.75193 13.0596 8.75193 13.75C8.75193 14.4404 9.31157 15 10.0019 15C10.6923 15 11.2519 14.4404 11.2519 13.75C11.2519 13.0596 10.6923 12.5 10.0019 12.5Z",
    fill: "#D9BD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIncompleta);
export default __webpack_public_path__ + "static/media/ico-incompleta.8a933f795f96987d633a89eba5a8b2e3.svg";
export { ForwardRef as ReactComponent };